import { ChatSentBotWidgetWrapper } from "./style";

export const ChatSentBotWidget = ({ children }: any) => {
  return (
    <ChatSentBotWidgetWrapper className="ChatSentBotWidget">
      <div style={{ whiteSpace: "pre-wrap" }}>{children}</div>
    </ChatSentBotWidgetWrapper>
  );
};
